import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { PARTNER_KEY } from './keys';
import { EventApi } from 'api';

function useGetPartner(id: string) {
  return useAuthQuery(
    getQueryKeys(PARTNER_KEY).detail(id),
    () => EventApi.getPartner(id),
    {
      select: (data) => data.data,
      enabled: !!id,
    },
  );
}

export default useGetPartner;
